export default "__VITE_ASSET__BVtsRpdC__"